const actionTypes = require('constants/actionTypes');
const signaturePatternActions = require('actions/signaturePattern');
const cardReplaceActions = require('actions/cardReplace');
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const trim = require('lodash/string/trim');

function reset() {
    return {
        type: actionTypes.CARD_BLOCK_RESET
    };
}

function setMotive(motive) {
    return {
        type: actionTypes.CARD_BLOCK_MOTIVE,
        payload: {
            motive
        }
    };
}

function setCardReplace(cardReplace) {
    return {
        type: actionTypes.CARD_BLOCK_REQUEST_CARD_REPLACE,
        payload: {
            cardReplace
        }
    };
}

function setComments(comments) {
    return {
        type: actionTypes.CARD_BLOCK_COMMENTS,
        payload: {
            comments
        }
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.CARD_BLOCK_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function validateStep(step) {
    return {
        type: actionTypes.CARD_BLOCK_VALIDATE_STEP,
        payload: {
            step
        }
    }
}

function setWillCancel(willCancel) {
    return {
        type: actionTypes.CARD_BLOCK_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

function setBlockRequest() {
    return {
        type: actionTypes.CARD_BLOCK_REQUEST
    };
}

function setBlockAndReplaceSuccess(){
    return {
        type: actionTypes.CARD_BLOCK_AND_REPLACE_SUCCESS
    };
}

function setBlockSuccess(response) {
    return {
        type: actionTypes.CARD_BLOCK_SUCCESS,
        payload: {
            cardNewStatus: trim(response.situacionContrato) || 'CANCELADA'
        }
    };
}

function setBlockFailure(error) {
    return {
        type: actionTypes.CARD_BLOCK_FAILURE,
        payload: {
            error
        }
    };
}

const setCardBlock = (cardId) => (dispatch, getState) => {

    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immCardBlockData = getState().cardBlock.getIn(['steps', 0]);

        //@ Complete comments with motive if no comments, as its a required field.
        const comments = immCardBlockData.get('comments') || immCardBlockData.get('motive');

        const requestData = {
            query: {
                dataToken,
                numeroTarjeta: immCard.get('number'),
                conratoMediosPago: {
                    numerodecontrato: immCard.getIn(['contract', 'number']),
                    producto: immCard.getIn(['contract', 'product'])
                },
                contrato: {
                    numerodecontrato: immCard.getIn(['contract', 'number']),
                    producto: immCard.getIn(['contract', 'product'])
                },
                indaral: "1",
                tipoBloqueo: '10', //@ This is not hardcoded. It use the same code for theft and loss.
                observaciones: comments
            }
        };

        dispatch(setBlockRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('cardBlock') , requestData)
            .then(response => {
                if (immCardBlockData.get('cardReplace')) {
                    dispatch(cardReplaceActions.replaceCardCallback(cardId, dataToken))
                        .then(() => {
                            dispatch(setBlockAndReplaceSuccess());
                            dispatch(setBlockSuccess(response));
                            dispatch(cardReplaceActions.clearCardReplace());
                        })
                        .catch(() => {
                            dispatch(setBlockSuccess(response));
                            dispatch(cardReplaceActions.clearCardReplace());
                        });
                } else {
                    dispatch(setBlockSuccess(response));
                }
            })
            .catch(response => dispatch(setBlockFailure(response.error.description)));
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    reset,
    setCardBlock,
    setCardReplace,
    setComments,
    setMotive,
    setVisibleStep,
    setWillCancel,
    validateStep
}
